import { render, staticRenderFns } from "./ImportRooms.vue?vue&type=template&id=1c956c50"
import script from "./ImportRooms.vue?vue&type=script&lang=js"
export * from "./ImportRooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports